import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faGlobe);

@Component({
  name: 'bpc-input-group',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class InputGroup extends mixins(AbstractField) {
  @Prop([String, Number]) readonly value: string | number;

  get model(): string {
    if (this.value || this.value === 0) {
      if (this.fieldAttributes['type'] != 'number') {
        return String(this.value);
      } else {
        if (typeof this.value === 'string') {
          return this.value.replace(',', '.');
        } else if (typeof this.value === 'number') {
          return this.formatNumber(this.value);
        }
      }
    } else {
      return null;
    }
  }
  set model(val: string) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  formatNumber(value: number): string {
    const step = this.fieldAttributes['step'] || '.01';
    const afterDecimalPoint = String(step).split('.')[1] || '';
    const numOfDecimals = afterDecimalPoint.length;

    const rounded = Math.round(value * 10 ** numOfDecimals) / 10 ** numOfDecimals;
    return String(rounded);
  }

  // updated () { }

  extendHandleEvent(eventName: string, event: any, val: any) {
    console.log('extendHandleEvent', eventName, event, val);
    if (event.action === 'changeAppendIcon') {
      this.changeAppendIcon(val);
    }
  }

  customAppendIcon: string = null;

  get inputAppendIcon() {
    return this.customAppendIcon ? this.customAppendIcon : this.appendIcon;
  }

  changeAppendIcon(type) {
    switch (type) {
      case 'percent':
        this.customAppendIcon = 'percent';
        break;
      case 'money':
        this.customAppendIcon = 'euro-sign';
        break;
      case 'percentage':
        this.customAppendIcon = 'percent';
        break;
      case 'fixed':
        this.customAppendIcon = 'euro-sign';
        break;
      default:
        this.customAppendIcon = null;
    }
  }

  onlyForCurrency($event) {
    if (
      this.fieldAttributes['step'] &&
      this.fieldAttributes['step'] === '.01' &&
      typeof this.model == 'string'
    ) {
      const valueWithDot = this.model.replace(',', '.');
      let parsedFloat = null;
      let formatedCurrency = this.model;
      if (valueWithDot.indexOf('.') > -1) {
        parsedFloat = parseFloat(valueWithDot);
        formatedCurrency = parsedFloat.toFixed(2);
      }
      this.model = formatedCurrency;
    }
  }
}
